import React from 'react';
import classnames from 'classnames';
import { object } from 'prop-types';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import HrbTranslate from '../../../components/language/HrbTranslate';
import EmdashText from '../../../components/library/common/EmdashText';
import InternalLink from '../../../router/InternalLink';
import { hasValue } from '../../../services/util/CommonUtil';
import { useHistory } from 'react-router-dom';

const OfficeListTableRow = ({ office }) => {

    // as per spec, if the average time to file for an office 
    // hits this threshold, we'll display it in bold.
    const agingThresholdDays = 6;

    const history = useHistory();

    const handleClick = (ev) => {
        ev.preventDefault()
        ev.stopPropagation();

        history.push(`/offices/${office.officeId}`);
    }

    return (
        <div className={classnames('columns light-grey px-3',
            { 'has-text-weight-bold': office.averageFileTimeDays >= agingThresholdDays }, 'div-hover')} onClick={handleClick}>
            <div className='column is-3 office-description'>
                <div><span className='is-unselectable'>{office.officeId}</span></div>
                <div><span className='is-unselectable'>{office.friendlyName}</span></div>
            </div>
            <div className='column is-2'>
                <HrbTranslate text={`DistrictPage.OfficeType.${office.officeType}`} />
            </div>
            <div className='column'>
                <span className='is-unselectable'>{office.newReturns}</span>
            </div>
            <div className='column'>
                <span className='is-unselectable'>{office.inProgressReturns}</span>
            </div>
            <div className='column'>
                <span className='is-unselectable'>{office.filedReturns}</span>
            </div>
            <div className='column is-2'>
                {!hasValue(office.averageFileTimeDays) ?
                    <EmdashText /> :
                    <HrbTranslate text={`Common.${office.averageFileTimeDays === 1 ? 'Day' : 'Days'}`}
                                  params={{Days: office.averageFileTimeDays}}/>
                }
                <InternalLink elementId={`link-office-${office.officeId}`} to={`/offices/${office.officeId}`} className='is-pulled-right' useLinkBehavior>
                    <ChevronRightIcon />
                </InternalLink>
            </div>
        </div>
    )
}

OfficeListTableRow.propTypes = {
    office: object.isRequired
}

export default OfficeListTableRow